import { makeAutoObservable, runInAction } from "mobx";
import {
  patientManagementNotificationPatient
} from "../Notification/NotificationPatientService";
import "react-toastify/dist/ReactToastify.css";
import i18n from "i18n";
import { toast } from "react-toastify";

export default class PatientLateAppointmentStore {
  patientList = [];
  totalElements = 0;
  totalPages = 0;
  page = 1;
  rowsPerPage = 10;
  loadingInitial = false;
  searchObject = {
    gender: "",
    keyword: "",
    patientType: null,
    registerType: null,
    idNumber: "",
    nationality: null,
    profession: null,
    religion: null,
    ethnics: null,
    org: null,
    currentRegion: null,
    currentProvince: null,
    currentDistrict: null,
    currentWard: null,
    patientTransfer: null,
    typeOfPatient: null,
    patientName:null,
    phoneNumber:null,
    medicalInsurance:null,
    fromAge:null,
    toAge:null,
    codeBnql:null,
    currentUnit:null,
    transferStatus: null,
    statusAdsm: null,
    typeOfPatient: null
  };
  constructor() {
    makeAutoObservable(this);
  }

  setLoadingInitial = (state) => {
    this.loadingInitial = state;
  };

  handleSetSearchObject = (item) => {
    if (item.pageIndex) {
      this.page = item.pageIndex;
    }
    this.searchObject = item;
  }

  pagingPatient = async () => {
    this.loadingInitial = true;
    let newSearchObj = {
      pageIndex: this.page,
      pageSize: this.rowsPerPage,
      keyword: this.searchObject.keyword,
      idNumber: this.searchObject.idNumber,
      gender: this.searchObject.gender,
      professionId: this.searchObject.profession?.id,
      nationalityId: this.searchObject.nationality?.id,
      religionId: this.searchObject.religion?.id,
      ethnicsId: this.searchObject.ethnics?.id,
      orgId: this.searchObject.currentUnit?.id,
      regionId: this.searchObject.currentRegion?.id,
      provinceId: this.searchObject.currentProvince?.id,
      districtId: this.searchObject.currentDistrict?.id,
      wardId: this.searchObject.currentWard?.id,
      patientTransfer: this.searchObject.patientTransfer,
      typeOfPatient: this.searchObject.typeOfPatient,
      patientType: this.searchObject.patientType,
      sortByDateEncounterDesc: this.searchObject.sortByDateEncounterDesc,
      registerType: this.searchObject.registerType,
      patientName:this.searchObject.patientName,
      phoneNumber:this.searchObject.phoneNumber,
      medicalInsurance:this.searchObject.medicalInsurance,
      fromAge:this.searchObject.fromAge,
      toAge:this.searchObject.toAge,
      transferStatus: this.searchObject.transferStatus,
      statusAdsm: this.searchObject.statusAdsm,
      typeNotification: this.searchObject.typeNotification
    };
    try {
      let data = await patientManagementNotificationPatient(newSearchObj);
      runInAction(() => {
        this.patientList = data.data.content;
        this.totalElements = data.data.totalElements;
        this.totalPages = data.data.totalPages;
      });

      this.setLoadingInitial(false);
    } catch (error) {
      console.log(error);
      toast.warning(i18n.t("toast.error"));
      this.setLoadingInitial(false);
    }
  };

  setPage = (page) => {
    this.page = page;
    this.pagingPatient();
  };

  setRowsPerPage = (event) => {
    this.rowsPerPage = event.target.value;
    this.page = 1;
    this.pagingPatient();
  };

  handleChangePage = (event, newPage) => {
    this.setPage(newPage);
  };

}
